import {useCallback} from 'react'
import {usePreloadedQuery, useQueryLoader} from 'react-relay'
import type {PreloadedQuery} from 'react-relay/relay-hooks/EntryPointTypes'
import type {GraphQLTaggedNode, OperationType, VariablesOf} from 'relay-runtime'

export function useRefetchablePreloadedQuery<TQuery extends OperationType>(
  gqlQuery: GraphQLTaggedNode,
  preloadedQuery: PreloadedQuery<TQuery>,
): [TQuery['response'], (variables: VariablesOf<TQuery>) => void] {
  const [currentQuery, doRefetch] = useQueryLoader(gqlQuery, preloadedQuery)
  const refetch = useCallback(
    (variables: VariablesOf<TQuery>) => {
      doRefetch(variables, {
        fetchPolicy: 'store-and-network',
        networkCacheConfig: {metadata: {isRefetch: true}},
      })
    },
    [doRefetch],
  )

  // workaround for "Expected preloadedQuery to not be disposed yet"
  if (IS_STORYBOOK && currentQuery?.isDisposed) {
    throw Promise.resolve()
  }

  const data = usePreloadedQuery(gqlQuery, currentQuery ?? preloadedQuery)
  return [data, refetch]
}
